export default {
  data() {
    return {
      worldWidth: 800,
      worldHeight: 600,

      x: 0,
      y: 0,
      width: 800,
      height: 600,

      targetX: 0,
      targetY: 0,
      targetWidth: 800,
      targetHeight: 600,

      dragging: false,
      lastPointer: { x: 0, y: 0 },

      animating: false,

      wheelAccum: 0,
      lastWheelTime: 0,

      pinchStartDistance: null,
      pinchStartWidth: null,
      pinchStartHeight: null,
      pinchCenter: { x: 0, y: 0 },

      tapStart: null,
      tapCancelled: false,
      
    }
  },
  computed: {
    viewBox() {
      return `${this.x} ${this.y} ${this.width} ${this.height}`
    },
    worldViewBox() {
      return `0 0 ${this.worldWidth} ${this.worldHeight}`
    }
  },
  methods: {
    updateSvgViewBox() {
      if (this.svgRoot) {
        this.svgRoot.setAttribute('viewBox', this.viewBox)
      }
    },

    // ---- Animations-Loop ----
    startAnimationLoop() {
      if (this.animating) return
      this.animating = true
      const step = () => {
        const dx = this.targetX - this.x
        const dy = this.targetY - this.y
        const dw = this.targetWidth - this.width
        const dh = this.targetHeight - this.height

        this.x += dx * this.easeFactor
        this.y += dy * this.easeFactor
        this.width += dw * this.easeFactor
        this.height += dh * this.easeFactor

        this.updateSvgViewBox()

        const stillMoving =
          Math.abs(dx) > 0.05 || Math.abs(dy) > 0.05 ||
          Math.abs(dw) > 0.05 || Math.abs(dh) > 0.05

        if (stillMoving) {
          requestAnimationFrame(step)
        } else {
          this.x = this.targetX
          this.y = this.targetY
          this.width = this.targetWidth
          this.height = this.targetHeight
          this.updateSvgViewBox()
          this.animating = false
        }
      }
      requestAnimationFrame(step)
    },

    // ---- Zoom ----
    zoomToPoint(direction, screenX, screenY, step) {
      const scale = this.targetWidth / this.worldWidth
      let newScale = scale + direction * step
      newScale = Math.min(this.maxScale, Math.max(this.minScale, newScale))

      const newWidth = this.worldWidth * newScale
      const newHeight = this.worldHeight * newScale

      let focusX = this.targetX + this.targetWidth / 2
      let focusY = this.targetY + this.targetHeight / 2

      if (screenX !== undefined && screenY !== undefined) {
        const viewportEl = this.$refs.viewport
        const rect = viewportEl.getBoundingClientRect()
        const ratioX = (screenX - rect.left) / rect.width
        const ratioY = (screenY - rect.top) / rect.height
        focusX = this.targetX + ratioX * this.targetWidth
        focusY = this.targetY + ratioY * this.targetHeight
      }

      const ratioFX = (focusX - this.targetX) / this.targetWidth
      const ratioFY = (focusY - this.targetY) / this.targetHeight

      this.targetWidth = newWidth
      this.targetHeight = newHeight
      this.targetX = focusX - ratioFX * newWidth
      this.targetY = focusY - ratioFY * newHeight

      this.clampTarget()
      this.startAnimationLoop()
    },
    zoom(direction) {
      this.zoomToPoint(direction, undefined, undefined, this.zoomStep)
    },
    onWheel(e) {
      if (!this.wheelZoomEnabled) return
      e.preventDefault()

      const now = Date.now()
      this.wheelAccum += Math.abs(e.deltaY)

      if (now - this.lastWheelTime < this.wheelCooldown) return
      if (this.wheelAccum < this.wheelThreshold) return

      this.wheelAccum = 0
      this.lastWheelTime = now

      this.zoomToPoint(e.deltaY > 0 ? 1 : -1, e.clientX, e.clientY, this.zoomStep)
    },
    onDoubleClick(e) {
      if (!this.doubleClickZoomEnabled) return
      this.zoomToPoint(-1, e.clientX, e.clientY, this.dblClickZoomStep)
    },

    // ---- Pan über Steuerkreuz ----
    pan(dx, dy) {
      const scale = this.targetWidth / this.worldWidth
      this.targetX += dx * this.panStep * scale
      this.targetY += dy * this.panStep * scale
      this.clampTarget()
      this.startAnimationLoop()
    },

    // ---- Pan/Pinch über Drag (Maus & Touch) ----
    getPointer(e) {
      if (e.touches && e.touches.length) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY }
      }
      return { x: e.clientX, y: e.clientY }
    },
    getTouchDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX
      const dy = touches[0].clientY - touches[1].clientY
      return Math.sqrt(dx * dx + dy * dy)
    },
    getTouchCenter(touches) {
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      }
    },
    startDrag(e) {
      if (e.touches && e.touches.length >= 2) {
        this.tapCancelled = true
      } else if (e.touches) {
        this.tapCancelled = false
        this.tapStart = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
          time: Date.now()
        }
      }

      if (this.pinchZoomEnabled && e.touches && e.touches.length === 2) {
        this.dragging = false
        this.pinchStartDistance = this.getTouchDistance(e.touches)
        this.pinchStartWidth = this.targetWidth
        this.pinchStartHeight = this.targetHeight
        this.pinchCenter = this.getTouchCenter(e.touches)
        return
      }

      this.dragging = true
      this.lastPointer = this.getPointer(e)
    },
    onDrag(e) {
      // Tap abbrechen, sobald der Finger sich merklich bewegt
      if (e.touches && this.tapStart && !this.tapCancelled) {
        if (e.touches.length >= 2) {
          this.tapCancelled = true
        } else {
          const dx = e.touches[0].clientX - this.tapStart.x
          const dy = e.touches[0].clientY - this.tapStart.y
          if (Math.sqrt(dx * dx + dy * dy) > 10) this.tapCancelled = true
        }
      }
      if (this.pinchZoomEnabled && e.touches && e.touches.length === 2) {
        if (this.pinchStartDistance === null) return

        const newDistance = this.getTouchDistance(e.touches)
        const scaleFactor = this.pinchStartDistance / newDistance

        let newWidth = this.pinchStartWidth * scaleFactor
        let newHeight = this.pinchStartHeight * scaleFactor

        const minWidth = this.worldWidth * this.minScale
        const maxWidth = this.worldWidth * this.maxScale
        newWidth = Math.min(maxWidth, Math.max(minWidth, newWidth))
        newHeight = newWidth * (this.pinchStartHeight / this.pinchStartWidth)

        const viewportEl = this.$refs.viewport
        const rect = viewportEl.getBoundingClientRect()
        const ratioX = (this.pinchCenter.x - rect.left) / rect.width
        const ratioY = (this.pinchCenter.y - rect.top) / rect.height

        const focusX = this.targetX + ratioX * this.targetWidth
        const focusY = this.targetY + ratioY * this.targetHeight

        this.targetWidth = newWidth
        this.targetHeight = newHeight
        this.targetX = focusX - ratioX * newWidth
        this.targetY = focusY - ratioY * newHeight

        this.clampTarget()
        this.x = this.targetX
        this.y = this.targetY
        this.width = this.targetWidth
        this.height = this.targetHeight
        this.updateSvgViewBox()

        return
      }

      if (!this.dragging) return
      const pointer = this.getPointer(e)
      const dxScreen = pointer.x - this.lastPointer.x
      const dyScreen = pointer.y - this.lastPointer.y
      this.lastPointer = pointer

      const viewportEl = this.$refs.viewport
      const scaleX = this.width / viewportEl.clientWidth
      const scaleY = this.height / viewportEl.clientHeight

      this.x -= dxScreen * scaleX
      this.y -= dyScreen * scaleY
      this.clampCurrent()
      this.updateSvgViewBox()

      this.targetX = this.x
      this.targetY = this.y
    },
    endDrag(e) {
      if (e && e.type === 'touchend' && e.touches.length === 0) {
        const isTap = !this.tapCancelled &&
          this.tapStart &&
          (Date.now() - this.tapStart.time) < 500

        if (isTap && e.changedTouches && e.changedTouches.length) {
          const t = e.changedTouches[0]
          this.handleTap(t.clientX, t.clientY)
        }
        this.tapStart = null
      }

      if (e && e.touches && e.touches.length < 2) {
        this.pinchStartDistance = null
      }
      this.dragging = false
    },

    // ---- Begrenzung ----
    clampCurrent() {
      const maxX = this.worldWidth - this.width
      const maxY = this.worldHeight - this.height
      this.x = Math.min(Math.max(this.x, 0), Math.max(maxX, 0))
      this.y = Math.min(Math.max(this.y, 0), Math.max(maxY, 0))
    },
    clampTarget() {
      const maxX = this.worldWidth - this.targetWidth
      const maxY = this.worldHeight - this.targetHeight
      this.targetX = Math.min(Math.max(this.targetX, 0), Math.max(maxX, 0))
      this.targetY = Math.min(Math.max(this.targetY, 0), Math.max(maxY, 0))
    }
  }
}
